import React from "react";
import { Helmet } from "react-helmet";
import QRCode from "qrcode.react";

const Shell = ({ children }) => (
  <>
    <Helmet>
      <title>한밭페이 | 로그인</title>
    </Helmet>
    <div className="login login-with-news-feed">
      <div className="news-feed">
        <div
          className="news-image"
          style={{
            backgroundImage: 'URL("../assets/img/admin/login-cover.png")',
            backgroundSize: "cover",
          }}
        ></div>
      </div>

      <div className="right-content">
        <div className="login-header">
          <div className="brand">
            <b>한밭페이</b> 관리자
            <small>지역화폐 호혜거래 시스템</small>
          </div>
        </div>

        <div className="login-content">
          {children}
          <hr />
          <p className="text-center text-grey-darker mb-0">
            © Hanbat Pay - WezONCoop All Rights Reserved.
          </p>
        </div>
      </div>
    </div>
  </>
);

export default ({
  userId,
  password,
  handleSubmit,
  loginType,
  setLoginType,
  loginTypes = [],
  step = "credentials",
  enroll,
  totpCode,
  setTotpCode,
  handleTotpSubmit,
  onCancelTotp,
  submitting,
}) => {
  // ── 인증 앱 최초 등록 ──
  if (step === "enroll" && enroll) {
    return (
      <Shell>
        <form className="margin-bottom-0" onSubmit={handleTotpSubmit}>
          <h4 className="f-w-600 m-b-5">인증 앱 등록</h4>
          <p className="text-grey-darker f-s-13 m-b-15">
            관리자 계정은 2차 인증이 필요합니다. 인증 앱(Google Authenticator,
            Authy 등)으로 아래 QR을 스캔한 뒤, 앱에 표시된 6자리 코드를
            입력해주세요.
          </p>

          <div className="text-center m-b-15">
            <div
              style={{
                display: "inline-block",
                padding: 12,
                background: "#fff",
                border: "1px solid #e2e7eb",
                borderRadius: 4,
              }}
            >
              <QRCode value={enroll.otpauthUri} size={180} />
            </div>
          </div>

          <div className="form-group m-b-15">
            <label className="f-w-600 f-s-12">
              QR을 못 읽으면 이 키를 직접 입력하세요
            </label>
            <input
              type="text"
              className="form-control"
              readOnly
              value={enroll.secret}
              onFocus={(e) => e.target.select()}
              style={{ fontFamily: "monospace", letterSpacing: 1 }}
            />
          </div>

          {enroll.recoveryCodes && enroll.recoveryCodes.length > 0 && (
            <div className="alert alert-warning m-b-15">
              <b className="d-block m-b-5">복구코드 (지금 저장하세요)</b>
              <span className="f-s-12 d-block m-b-10">
                폰을 잃어버렸을 때 로그인할 수 있는 1회용 코드입니다. 이 화면을
                벗어나면 다시 볼 수 없습니다.
              </span>
              <div
                style={{
                  fontFamily: "monospace",
                  fontSize: 13,
                  columnCount: 2,
                  lineHeight: 1.8,
                }}
              >
                {enroll.recoveryCodes.map((c) => (
                  <div key={c}>{c}</div>
                ))}
              </div>
            </div>
          )}

          <div className="form-group m-b-15">
            <input
              type="text"
              className="form-control form-control-lg text-center"
              placeholder="앱에 표시된 6자리 코드"
              inputMode="numeric"
              autoComplete="one-time-code"
              maxLength={6}
              autoFocus
              value={totpCode}
              onChange={(e) =>
                setTotpCode(e.target.value.replace(/[^0-9]/g, ""))
              }
              style={{ letterSpacing: 6, fontFamily: "monospace" }}
            />
          </div>

          <div className="login-buttons">
            <button
              type="submit"
              className="btn btn-primary btn-block btn-lg"
              disabled={submitting}
            >
              {submitting ? "확인 중..." : "등록하고 로그인"}
            </button>
          </div>
          <div className="text-center m-t-10">
            <button
              type="button"
              className="btn btn-link btn-sm"
              onClick={onCancelTotp}
            >
              처음으로
            </button>
          </div>
        </form>
      </Shell>
    );
  }

  // ── 2단계: 인증 코드 입력 ──
  if (step === "totp") {
    return (
      <Shell>
        <form className="margin-bottom-0" onSubmit={handleTotpSubmit}>
          <h4 className="f-w-600 m-b-5">2차 인증</h4>
          <p className="text-grey-darker f-s-13 m-b-20">
            인증 앱에 표시된 6자리 코드를 입력해주세요. 앱을 쓸 수 없으면
            복구코드를 입력해도 됩니다.
          </p>

          <div className="form-group m-b-15">
            <input
              type="text"
              className="form-control form-control-lg text-center"
              placeholder="6자리 코드 또는 복구코드"
              autoComplete="one-time-code"
              autoFocus
              value={totpCode}
              onChange={(e) => setTotpCode(e.target.value)}
              style={{ letterSpacing: 3, fontFamily: "monospace" }}
            />
          </div>

          <div className="login-buttons">
            <button
              type="submit"
              className="btn btn-primary btn-block btn-lg"
              disabled={submitting}
            >
              {submitting ? "확인 중..." : "확인"}
            </button>
          </div>
          <div className="text-center m-t-10">
            <button
              type="button"
              className="btn btn-link btn-sm"
              onClick={onCancelTotp}
            >
              처음으로
            </button>
          </div>
        </form>
      </Shell>
    );
  }

  // ── 1단계: 아이디·비밀번호 ──
  return (
    <Shell>
      <form className="margin-bottom-0" onSubmit={handleSubmit}>
        <div className="form-group m-b-15">
          <label className="f-w-600 f-s-13">로그인 유형</label>
          <div className="btn-group" style={{ display: "flex" }}>
            {loginTypes.map((t) => (
              <button
                key={t.id}
                type="button"
                style={{ flex: 1 }}
                className={
                  "btn " + (loginType === t.id ? "btn-primary" : "btn-white")
                }
                onClick={() => setLoginType(t.id)}
              >
                {t.name}
              </button>
            ))}
          </div>
        </div>
        <div className="form-group m-b-15">
          <input
            type="text"
            className="form-control form-control-lg"
            placeholder="아이디 입력"
            required
            value={userId.value}
            onChange={userId.onChange}
          />
        </div>
        <div className="form-group m-b-15">
          <input
            type="password"
            className="form-control form-control-lg"
            placeholder="비밀번호 입력"
            required
            value={password.value}
            onChange={password.onChange}
          />
        </div>
        <div className="login-buttons">
          <button
            type="submit"
            className="btn btn-primary btn-block btn-lg"
            disabled={submitting}
          >
            {submitting ? "확인 중..." : "로그인"}
          </button>
        </div>
      </form>
    </Shell>
  );
};
